import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DoblesComponent } from './components/dobles/dobles.component';
import { MainComponent } from './main.component';

const routes:Routes = [
    {   
        path:'vencida',component:MainComponent,
        children:[
            {
                path:'dobles',component:DoblesComponent
            }
        ]
    }
]

@NgModule({
    imports:[
        RouterModule.forChild(routes)
    ]
})

export class CarterVencidaRoutingModule{
    
}